/**
 * Leaderboard points: how each kind is earned, and (optionally) where someone's points came from.
 * Rules come from the server (LeaderboardPoints::rules, editable settings). Points are separate
 * from the certificate.
 */

/** Source key (point reason) → label, in display order. */
export const SOURCES = [
  ["daily_question_correct", "Daily Challenge"],
  ["attendance", "Attendance"],
  ["assessment_passed", "Quizzes"],
  ["assignment_grade", "Assignments"],
];

const letters = (map, only) => Object.entries(map || {}).filter(([l]) => !only || only.includes(l)).map(([l, p]) => `${l} ${p}`).join(" · ");

export function pointsRows(r) {
  return [
    ["daily_question_correct", "Daily Challenge", `${r.daily_correct} for each correct answer`],
    ["attendance", "Attendance", `${r.attendance} for each class you attend, live or by watching the recording. Once per class, for the weekly lectures only: orientation, makeup classes and other sessions don't earn points.`],
    ["assessment_passed", "Quizzes", r.quiz_retry_step
      ? `${r.quiz_first} for passing (${r.quiz_pass}%+) on your first attempt, ${r.quiz_retry_step} less for each retry, at least ${r.quiz_min}. Once per quiz.`
      : `${r.quiz_first} for passing (${r.quiz_pass}%+), whichever attempt. Once per quiz.`],
    ["assignment_grade", "Assignments", `By grade: ${letters(r.assignment)}`],
  ];
}

export default function PointsRules({ rules, breakdown, title = "How you earn points" }) {
  if (!rules) return null;
  const rows = pointsRows(rules);
  return (
    <section className="card">
      <div className="card-h"><h3>{title}</h3>{breakdown && <small className="muted-note">Your points in this cohort</small>}</div>
      <div className="plain">
        <table className="gtable points-rules">
          <thead><tr><th>Activity</th><th>Points</th>{breakdown && <th className="mine">You Have</th>}</tr></thead>
          <tbody>
            {rows.map(([key, label, how]) => (
              <tr key={key}><td><strong>{label}</strong></td><td>{how}</td>{breakdown && <td className="mine">{breakdown[key] ?? 0}</td>}</tr>
            ))}
            {breakdown && (breakdown.other ?? 0) !== 0 && <tr><td><strong>Other</strong></td><td>Earlier point rules</td><td className="mine">{breakdown.other}</td></tr>}
          </tbody>
        </table>
      </div>
      <small className="muted-note">Points rank you on the leaderboard. They're separate from your certificate, and your capstone doesn't add points.</small>
    </section>
  );
}
